const fontSans = 'var(--app-font-sans), Inter, system-ui, sans-serif'

export const settingsSubheaderSx = {
  position: 'static',
  bgcolor: 'transparent',
  py: 0.375,
  px: 1.25,
  mt: '12px',
  mb: '8px',
  lineHeight: '13px',
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.01em',
  color: '#616161',
  fontFamily: fontSans,
}

export const settingsItemButtonSx = {
  py: 0.375,
  px: 1.25,
  mb: 0.125,
  minHeight: 32,
  height: 32,
  borderRadius: '12px',
  border: '1px solid transparent',
  fontFamily: fontSans,
  transition: 'background 0.2s ease, border-color 0.2s ease',
  '&:hover': {
    bgcolor: 'var(--app-secondary-nav-hover-accent, var(--app-left-nav-bg, #e8ded6))',
    borderColor: 'transparent',
  },
  '&.Mui-selected': {
    bgcolor: 'background.paper',
    borderColor: 'transparent',
    '&:hover': { bgcolor: 'background.paper' },
  },
  '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'var(--app-primary, #0078d4)', outlineOffset: 1 },
}

export const settingsItemIconSx = { minWidth: 28, mr: 0.75, justifyContent: 'center', color: '#424242' }

export const settingsItemTextPrimarySx = {
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '15px',
  color: '#0e0e0e',
  fontFamily: fontSans,
}
